import { AxiosPromise } from 'axios';
import axios from './axiosConfig';
import { StudyRoomVideo } from '../models/studyRoomVideo';

export const list = (staffId: number): AxiosPromise<StudyRoomVideo[]> => {
  return axios.get(`/api/studyroom/${staffId}`);
};
